// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfp_a bho_wj bho_ss bho_xl"};